export enum DprActivityData {
  CustomData = 1,
  Subactivities,
  Attachments,
}
